import { NextPage } from 'next';
import React from 'react';

import { Layout } from '../../../components';
import {
  JobDescriptionContainer,
  JobDescriptionTitle,
} from '../../../components/static/AboutUsContent/CareersContent/styles';
import MainBanner from '../../../components/MainBanner';
import { HistoryLine } from '../../../components/Shared/HistoryLine';
import { LayoutHelper } from '../../../components/Shared/Layout/styles';
import StyledReactMarkdown from '../../../components/Shared/StyledReactMarkdown';
import withStrapiDataValidator from '../../../hocs/withStrapiDataValidator';
import { getOpenPosition } from '../../api/careers';
import MetaTags from '../../../components/Metatags';

export const getServerSideProps = async (context: any) => {
  const { id } = context.query;
  let data = {};
  try {
    data = await getOpenPosition(id);
  } catch (error) {
    data = {};
  }
  return {
    props: {
      data,
    },
  };
};

const CareerDetail: NextPage = (props: any) => {
  const footerData = props?.footerData?.data?.attributes;
  const data = props?.data?.data?.attributes;

  const { role, jobDescription, seo } = data;

  return (
    <Layout footerData={footerData} activeNavIndex={3} title="Careers">
      <MetaTags title="Careers" seo={seo} />
      <HistoryLine />

      <MainBanner banners={[{ title: role }]} />

      <LayoutHelper sidePadding="135px" mediumPadding="50px" mobilePadding="20px">
        <JobDescriptionContainer>
          <JobDescriptionTitle>{role}</JobDescriptionTitle>
          <StyledReactMarkdown text={jobDescription} />
        </JobDescriptionContainer>
      </LayoutHelper>
    </Layout>
  );
};

export default withStrapiDataValidator(CareerDetail);
